import React from "react";
import "@splidejs/splide/dist/css/splide-core.min.css";
import CategoryCarouselSplide from './categoryCarouselSplide';

export const CategoryCarousel = ({id, label, link, items}) => {
    return (
        <div className="category-carousel">
            <div className="category-carousel-header">
                <h3 id={id} className="category-carousel-title">
                    {label}
                </h3>
                {link ? (
                    <a className="category-carousel-link" href={link}
                       onClick={(event) => {
                           appData.actionTrigger.dispatch({
                               trigger: "handleClickCategory",
                               payload: {
                                   eventLabel: label,
                                   eventAction: 'categorie niv2'
                               }
                           });
                       }}>
                        Tout l'univers
                    </a>
                ) : null}
            </div>
            <CategoryCarouselSplide id={id} label={label} link={link} items={items}/>
        </div>
    );
};